import {Pipe, PipeTransform} from '@angular/core';
import {priorityStrategies} from '@shared/modules/videos/models/video-priority-strategies';

@Pipe({
	standalone: true,
	name: 'priorityLabel',
})
export class PriorityLabelPipe implements PipeTransform {
	transform(value: string): string {
		const strategy = priorityStrategies.find(item => item.value === value);
		return strategy
			? strategy.translateKey
			: 'VIEWS.USER_BOARD.PRESETS.DIALOG.CONTENT.PRIORITY_STRATEGY.OPTIONS.NONE';
	}
}
